{
    "DefaultSet_Standard_Reports": "Rapports standard",
    "DefaultSet_Power_User_Reports": "Rapports des utilisateurs",
    "DefaultSet_Contact_Centre_Reports": "Rapports sur les centres de contact",
    "DefaultSet_Call_Centre_Reports": "Rapports sur les centres d'appels",
    "DefaultSet_SIP_Reports": "Rapports SIP",
    "NAME": "ReportingDefaultReportSets",
    "DefaultSet_Enhanced_Call_Centre_Reports": "Rapports améliorés sur les centres d'appel",
    "DefaultSet_Call_Centre_Agent_Reports": "Rapports sur les agents des centres d'appel",
    "DefaultSet_Essentials_Reports_MST": "Rapports standards CXA",
    "DefaultSet_Professional_Reports_MST": "Rapports CXA Premium",
    "DefaultSet_Call_Centre_Agent_Reports_MST": "Rapports CXE Premium",
    "DefaultSet_Call_Center_Reports": "Rapports sur les centres d'appel",
    "DefaultSet_Enhanced_Call_Center_Reports": "Rapports améliorés sur les centres d'appel"
}